export const splitString = (string) => {
  if (!string) return ''
  return `${string.substring(0, 4)}...${string.substring(string.length - 4, string.length)}`
}
